export const getTransDtls = (data) => {
    return `<?xml version="1.0" encoding="UTF-8"?>
    <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/"
        xmlns:ser="http://service.beyon.com/">
        <soapenv:Header>
            <wsse:Security soapenv:mustUnderstand="1"
                xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd"
                xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd">
                <wsse:UsernameToken wsu:Id="UsernameToken-D465EDF169877B75AD16092253318471">
                    <wsse:Username>dhofar</wsse:Username>
                <wsse:Password Type="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText">cTb%23jPmQ8</wsse:Password>
                </wsse:UsernameToken>
            </wsse:Security>
        </soapenv:Header>
        <soapenv:Body>
        <ser:getQuote>
         <quoteInfo>
         <civilId>${data.civilId || ''}</civilId>
         <mobileNo>${data.mobileNo || ''}</mobileNo>
         <plateNo>${data.plateNumber || ''}</plateNo>
         <policyNo>${data.policyNo || ''}</policyNo>
         <quoteNo>${data.quoteNo || ''}</quoteNo>
         <registrationMark>${data.plateCode || ''}</registrationMark>
         <srcBusId>${data.srcBusId}</srcBusId>
         <txnTyp>${data.txnTyp}</txnTyp>
          </quoteInfo>
        </ser:getQuote>
        </soapenv:Body>
    </soapenv:Envelope>`;
};
